import * as React from 'react'
import { FC, useCallback } from 'react'
import { BulkReopenForm } from '@user/components/xGrid'
import { ENTITY_TYPES } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { BulkReopenInput } from '@user/components/xGrid/atoms/BulkActions/typings/BulkReopen'
import { bulkReopenLeads } from '@user/store/lead'
import { useData } from '@user/components/Leads/LeadList/LeadBulkActions/Sidebars/hooks/useData'

export const BulkReopenLeads: FC = () => {
  const dispatch = useAppDispatch()
  const { status } = useData()

  const validateRows = useCallback(
    async (model: BulkReopenInput) => {
      const response = await dispatch(bulkReopenLeads({ model }))
      if (bulkReopenLeads.fulfilled.match(response)) {
        return response.payload.model
      }
    },
    [dispatch],
  )

  const onSubmit = useCallback(
    async (model: BulkReopenInput) =>
      void (await dispatch(
        bulkReopenLeads({
          model,
          mode: 'commit',
        }),
      )),
    [dispatch],
  )

  return (
    status === 'success' && (
      <BulkReopenForm
        entityType={ENTITY_TYPES.Lead}
        validateRows={validateRows}
        onSubmit={onSubmit}
      />
    )
  )
}
BulkReopenLeads.displayName = 'BulkReopenLeads'
